export const UGS_SHEET_MODES = {
  STARTED_UGS_SHEET: 'STARTED_UGS_SHEET',
  ENDED_UGS_SHEET: 'ENDED_UGS_SHEET',
  STARTED_UGS_SHEET_REVIEW: 'STARTED_UGS_SHEET_REVIEW',
  ENDED_UGS_SHEET_REVIEW: 'ENDED_UGS_SHEET_REVIEW',
  END_UGS_EXPERIENCE: 'END_UGS_EXPERIENCE',
};

export const UGS_SHEET_TYPE = {
  MASTERY: 'MASTERY',
  EXIT_TICKET: 'EXIT_TICKET',
};

export const UNGUIDED_SHEET_EVENT = {
  UNGUIDED_SHEET_EXPERIENCE: 'UNGUIDED_SHEET_EXPERIENCE',
};

export const DEFAULT_UGS_EXPERIENCE_API_KEY = 'ugs_experience_dummy_key';
export const UGS_ALL_QUESTIONS_CORRECTNESS = 'ugs_all_questions_correctness';
export const UGS_FIVE_MINUTES_WARNING = 5 * 60 * 1000; // in ms;
export const UGS_THREE_MINUTES = 3 * 60 * 1000; // in ms;
